import { types } from './webhookPixAutomatico.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'

const initialState = {
  id: 'webhookpixautomatico',
  selectedFilters: [],
  showHideColumns: [
    {
      label: 'Código',
      value: {
        field: 'oid',
        header: 'Código',
        columnKey: 'oid',
        sortable: true,
        columnSortField: 'oid',
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Descrição',
      value: {
        field: 'descricao',
        header: 'Descrição',
        columnKey: 'descricao',
        sortable: true,
        columnSortField: 'descricao',
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Tipo',
      value: {
        field: 'tipoDescricao',
        header: 'Tipo',
        columnKey: 'tipoDescricao',
        sortable: true,
        columnSortField: 'tipoDescricao',
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Status',
      value: {
        field: 'statusDescricao',
        header: 'Status',
        columnKey: 'statusDescricao',
        sortable: true,
        columnSortField: 'statusDescricao',
        filter: true,
        visible: true,
      },
    },
  ],
  columnsLookup: [
    {
      field: 'oid',
      header: 'Código',
      columnKey: 'oid',
      sortable: true,
      columnSortField: 'oid',
      filter: true,
      visible: true,
    },
    {
      field: 'descricao',
      header: 'Descrição',
      columnKey: 'descricao',
      sortable: true,
      columnSortField: 'descricao',
      filter: true,
      visible: true,
    },
  ],

  columns: [],
  currentRecord: {
    oid: '',
    descricao: '',
    webhookUrl: '',
    tipo: 'REC',
    status: '',
    statusDescricao: '',
    configuracaoPixAutomatico: {},
    ativo: true,
    responseInicial: '',
    mensagemErro: '',
  },
  messages: {},
  usaListDto: false,
  loadingCadastrar: false,
  loadingConsultar: false,
  loadingCancelar: false,
  pspResponse: null,
}

const reducer = new Reducer(initialState, types)

export function CRUDWebhookPixAutomaticoReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('webhookpixautomatico')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.RESET:
      return reset(state, action)
    case types.MAKE_NEW:
      return initialize(state)
    case types.SET_LOADING_CADASTRAR:
      return { ...state, loadingCadastrar: action.payload }
    case types.SET_LOADING_CONSULTAR:
      return { ...state, loadingConsultar: action.payload }
    case types.SET_LOADING_CANCELAR:
      return { ...state, loadingCancelar: action.payload }
    case types.SET_PSP_RESPONSE:
      return { ...state, pspResponse: action.payload }
    default:
      return state
  }
}

function reset(state, action) {
  return {
    ...state,
    currentRecord: initialState.currentRecord,
    records: [],
    selectedFilters: [],
    loadingCadastrar: false,
    loadingConsultar: false,
    loadingCancelar: false,
    pspResponse: null,
  }
}

const initialize = (state) => {
  const currentRecord = {
    ...initialState.currentRecord,
    tipo: 'REC',
    ativo: true,
  }
  return Object.assign({}, state, { currentRecord: currentRecord, pspResponse: null })
}
